




























import Vue from 'vue'
import { mapGetters } from 'vuex'
import CloseButton from '@/components/CloseButton.vue'
import User from '@/types/User.interface'
import tenantNavMixin from '@/mixins/tenant-nav-mixin'
import Credentials from '@/types/Credentials'
export default Vue.extend({
    components: { CloseButton },
    mixins: [tenantNavMixin],
    data() {
        return {
            loading: false,
            password: '',
            showPassword: false,
            hk: process.env.VUE_APP_HASH_KEY,
        }
    },
    computed: {
        ...mapGetters(['userTmp'])
    },
    methods: {
        isIntuitAppstore(): boolean {
            //  We know this registration is from intuit's appstore if the method is set
            return this.$route.query.method === 'subscribeFromAppstore'
        },
        async encryptForm(payload): Promise<Credentials> {
            const encoder = new TextEncoder()
            const secretBuffer = encoder.encode(this.hk)

            const hmacKey = await window.crypto.subtle.importKey(
                'raw',
                secretBuffer,
                {name: 'HMAC', hash: 'SHA-256'},
                false,
                ['sign']
            )

            const credentials = encoder.encode(JSON.stringify(payload))

            const signatureBuffer = await window.crypto.subtle.sign(
                'HMAC',
                hmacKey,
                credentials
            )

            return {
                hash: btoa(String.fromCharCode(...new Uint8Array(signatureBuffer))),
                email: payload.email,
                password: payload.password,
                created_at: payload.created_at
            }
        },
        async linkAccounts(): Promise<void> {
            //  validate the form
            const valid = await this.$validator.validate()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Else, assemble request payload
            const payload = {
                email: this.userTmp.email,
                password: this.password,
                created_at: Date.now()  
            }

            //  Start the loading spinner
            this.loading = true

            const encryptedForm = await this.encryptForm(payload)

            //  Send the request
            const user = await this.$store.dispatch('linkAccounts', encryptedForm)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!user) return

            //  If we landed here during the 'GET APP NOW' workflow, we have special handling
            if (this.isIntuitAppstore()) return this.subscribeFromAppstore(user)

            //  Else, use standard login
            this.routeLogin(user)
        },
        subscribeFromAppstore(user: User): void {
            //  Check the user for tenant memberships
            const memberships = user.memberships

            //  If the user has at least one tenant, resume normal workflow
            if (memberships.length > 0) return this.routeLogin(user)

            //  Else, nav to register/authenticated attaching 'subscribeFromAppstore' method
            this.$router.push('/register/authenticated?method=subscribeFromAppstore')
        }
    }
})
